// Depoimentos reais publicados por clientes no perfil do Google da STIB.
// Textos mantidos como foram escritos pelos autores. Sem foto, sem cargo inventado.
// Fonte única para todo o site — não criar listas paralelas.

export interface Depoimento {
  nome: string;
  texto: string;
  /** Contexto citado pelo próprio autor no depoimento, quando houver. */
  contexto?: string;
  /** true = fala de evento com palestra silenciosa / fones sem fio */
  palestra?: boolean;
}

export const depoimentos: Depoimento[] = [
  {
    nome: 'Claudia UFM',
    texto: 'A equipe da Stib foi extremamente atenciosa, cuidadosa, procurando nos atender em todas as nossas necessidades. Além disso, realizaram um serviço primoroso de tradução simultaneamente durante o Workshop de encerramento do Projeto CDC-APS realizado na sede da OPAS em Brasília, março/2026.',
    contexto: 'Workshop do Projeto CDC-APS · OPAS, Brasília',
  },
  {
    nome: 'Bruno Lemes',
    texto: 'Trabalhar com a STIB é sempre uma experiência muito positiva. A equipe é extremamente profissional, flexível e comprometida em atender às mais variadas demandas com qualidade impecável. As entregas são sempre pontuais e consistentes, o que reforça a cada projeto minha confiança absoluta no trabalho deles. Recomendo de olhos fechados!',
  },
  {
    nome: 'Denise Flesch',
    texto: 'Uma das melhores equipes de tradução com quem já trabalhei. Desde o atendimento, à delicadeza e cuidado dos tradutores com um assunto delicado e sensível, enfim, recomendo fortemente.',
  },
  {
    nome: 'Marcia Leão',
    texto: 'A STIB foi uma maravilhosa parceria que desenvolvemos. Chegamos até a empresa procurando para um trabalho específico de tradução, de lá para cá, em mais de um ano de relacionamento, já tivemos outros trabalhos e sempre com uma excelente qualidade e atendimento atencioso e personalizado.',
  },
  {
    nome: 'Alex Esposito',
    texto: 'Gostaria de agradecer o excelente serviço prestado por sua empresa. Seus intérpretes são pessoas dotados de extraordinário dom o qual impressiona quem assiste. A equipe muito educada e seu atendimento prestativo e rápido nos ajudou muito. Recomendo a todos que procuram um serviço de tradução simultânea.',
  },
  {
    nome: 'Sandra Sobral',
    texto: 'A STIB prestou um serviço de tradução em uma simpósio internacional de acolhimento familiar (IV SIMAF) que organizamos na UNICAMP em março de 2023. O serviço foi excelente, superou nossas expectativas.',
    contexto: 'IV SIMAF · UNICAMP',
  },
  {
    nome: 'Ariel Rodrigues dos Santos',
    texto: 'A STIB oferece um serviço em tradução/interpretação simultânea. A experiência do TRT da 14ª Região com a empresa é das melhores!',
    contexto: 'TRT da 14ª Região',
  },
  {
    nome: 'Larissa Padilha',
    texto: 'Contratamos a STIB para uma palestra silenciosa no stand que tivemos em um congresso e eles foram ótimos, mto elogiados e prestativos! E a palestra foi o diferencial do stand :)',
    contexto: 'Palestra silenciosa em stand de congresso',
    palestra: true,
  },
  {
    nome: 'Gabriel Leôncio',
    texto: 'A qualidade do serviço deles é simplesmente excelente! Apesar da preocupação antes das apresentações, deu tudo certo. Nosso evento foi impecável! Parabéns à equipe técnica e aos tradutores.',
    palestra: true,
  },
  {
    nome: 'Marcos Henrique',
    texto: 'A STIB presta um ótimo serviço. Os intérpretes Inglês - Português são bons comunicadores, bem preparados e muito simpáticos. O tratamento pela equipe foi também sempre cortês.',
  },
  {
    nome: 'Carolina Lobo',
    texto: 'Ótimos parceiros! Ótimos profissionais! Acompanhamento pré, durante e pós evento maravilhoso!!',
    palestra: true,
  },
  {
    nome: 'André Rios',
    texto: 'Equipe muito atenciosa e profissional. Atenta a cada detalhe do evento. Profissional de tradução excelente.',
  },
  {
    nome: 'Adriana Silva',
    texto: 'A empresa STIB nos atende há algum tempo, sempre com muito profissionalismo, pontualidade e acima de tudo com muita gentileza. Super recomendo!',
    palestra: true,
  },
  {
    nome: 'Farley Miranda',
    texto: 'Fizemos um evento no prédio da Procuradoria Geral e o trabalho da profissional foi impecável, inclusive ajudando a orquestra que estava presente para apresentação.',
    contexto: 'Evento na Procuradoria Geral',
  },
  {
    nome: 'Paula Ladeira Prates',
    texto: 'Empresa extremamente confiável, com profissionais excelentes e serviços de altíssima qualidade!',
    palestra: true,
  },
  {
    nome: 'Marilia Pinto',
    texto: 'Excelente atendimento! Profissionais comprometidos e super competentes.',
    palestra: true,
  },
  {
    nome: 'Heloisa Valadares',
    texto: 'Equipe comprometida e preparada. Excelente!',
    palestra: true,
  },
  {
    nome: 'Claudia Couto',
    texto: 'Equipe pontual, comprometida e muito bem preparada tecnicamente.',
    palestra: true,
  },
  {
    nome: 'Romi Márcia Bencke',
    texto: 'Excelente trabalho. Bastante pontuais e atenciosos.',
    palestra: true,
  },
  {
    nome: 'Danna Martins',
    texto: 'Fizemos um evento na PF, o qual foi muito bem executado. Profissionais e um bom custo benefício.',
    contexto: 'Evento na Polícia Federal',
    palestra: true,
  },
  {
    nome: 'Thereza Shelly Leite Barros',
    texto: 'Tive a oportunidade de trabalhar com STIB em um evento online. Os tradutores foram super profissionais e desenvolveram um ótimo trabalho. Espero contar com os serviços desta empresa novamente. Obrigada!',
    contexto: 'Evento online',
  },
  {
    nome: 'Pupila Experiências Criativas',
    texto: 'Excelente trabalho de tradução. Equipe atenciosa, parceira e competente. Recomendamos muito o trabalho de tradução do português para o inglês britânico.',
  },
  {
    nome: 'Ferraz & Mendes Sociedade de Advogados',
    texto: 'Foi excelente trabalhar com a STIB.',
    palestra: true,
  },
  {
    nome: 'Mike Amisi',
    texto: 'Ótimo serviço.',
    palestra: true,
  },
];

/** Depoimentos que servem também às páginas de palestra silenciosa / fones sem fio. */
export const depoimentosPalestra = depoimentos.filter((d) => d.palestra);

/** Atalho para seções que mostram poucos. */
export const escolher = (n: number, lista: Depoimento[] = depoimentos) => lista.slice(0, n);

export const FONTE_GOOGLE =
  'https://www.google.com/search?q=STIB+Tradu%C3%A7%C3%A3o+Simult%C3%A2nea+e+Palestra+Silenciosa&stick=H4sIAAAAAAAA_-NgU1I1qLA0SU41NU8yTzUytzBKMjW2AgoZpSWmJJmmpiaZm5ikJaUuYjUMDvF0UggpSkwpPbz88OJ8heDM3NKcksOL8lITFVIVAhJzUotLihKBwjmpecmZ-cWJABSK5ppdAAAA&hl=pt-BR';
